import React from "react";
import {Card, Container, Col, Row, Header, Footer} from "@deere/ux.uxframe-react";
import { ReactComponent as WarningIcon } from "@deere/ux.brand-foundations/icons/warning.svg";

function ErrorPage() {
    return (
        <div className={"uxf-sticky-footer"}>
            <Header pageHeading={"Prospective Supplier"}/>
            <main className={"container-fluid bg-gray pt-1 pb-1"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Row>
                    <Col>
                        <div className="uxf-error-example d-flex justify-content-center flex-wrap text-center">
                            <Card
                                className="card w-100 align-items-center"
                                style={{ maxWidth: "525px" }}
                            >
                                <Card.Header style={{width: "100%"}}><strong>Authorization Error</strong></Card.Header>
                                <Card.Body className="card-body w-100">
                                    <WarningIcon width="200px" height="200px" fill="#aaa" />
                                    <p className="w-100">
                                        Oops! You are not authorized to view this information. Please try accessing the
                                        page again.
                                    </p>
                                    <p className="text-muted w-100">
                                        Contact <a href="https://jdsn.deere.com/wps/portal/jdsn/JDSN/new/!ut/p/z1/hY_NDoJADISfyLT8bfCIiqyLgkQF6YUQQwyJrIaAz-9G9Mhub03nm5kCwRVI1u_2Xg_tU9YPtZfEqqW9R-SunfjnI8PM8WwRxqmDMUJhEpA648wEf_4QbcLIca3EXwkPg60lEp56OcvYlzfmz_HrKV9jP_GaggY-BwK6jX3fyAHKoR8bZUna1q71E-hStbnqLY4gTN1e3UVNV512i_ADUzlY_w!!/dz/d5/L2dBISEvZ0FBIS9nQSEh/?uri=nm:oid:Z6_92L00H42N8TP60Q352JEKO30I0">Application Support</a> for more
                                        information.
                                    </p>
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </main>
            <Footer/>
        </div>
    );
}

export default ErrorPage;